import React from 'react';
import './ItemHeader.css';

const TXT_LVL = { fr: 'niv.', en: 'lvl.', de: 'Stufe', es: 'niv.', pt: 'nív.' };

const ItemHeader = ({ item, lang = 'fr' }) => {
    if (!item) return null;

    const itemTypeName = item.type ? item.type.name[lang] : '';
    const itemTypeIcon = item.type ? item.type.img : null;

    return (
        <div className="item-header">
            <div className="item-header-info">
                {itemTypeName && (
                    <h6 className="item-header-type">
                        {itemTypeIcon && <img src={itemTypeIcon} className="item-header-type-icon" alt={itemTypeName} />}
                        <span>{itemTypeName}</span>
                    </h6>
                )}
                <h6 className="item-header-level">
                    <span className="item-header-level-label">{TXT_LVL[lang] || TXT_LVL.en}</span>
                    <span className="item-header-level-value">{item.level}</span>
                </h6>
            </div>
        </div>
    );
};

export default ItemHeader;
